import { Component, Inject } from '@angular/core';
import { OktaAuth } from '@okta/okta-auth-js';
import { OKTA_AUTH, OktaAuthStateService } from '@okta/okta-angular';

@Component({
  selector: 'app-login',
  template: `
    <button mat-raised-button (click)="login()">Mit Okta anmelden</button>
  `
})
export class LoginComponent {
  constructor(
    @Inject(OKTA_AUTH) private oktaAuth: OktaAuth,
    public authState: OktaAuthStateService
  ) {}
  async login() {
    await this.oktaAuth.signInWithRedirect();
  }
}
